import type { Appointment } from '../utils/appointmentManager';

/** Human-readable label for a payment method id stored on appointment.paymentData. */
export function formatBookingPaymentMethod(method?: string | null): string {
  if (!method) return 'Card';
  const m = String(method).toLowerCase();
  const labels: Record<string, string> = {
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    credit_card: 'Card',
    venmo: 'Venmo',
    pay_later: 'Pay at visit',
  };
  return labels[m] || String(method).replace(/_/g, ' ');
}

/** Customer prepaid when booking (saved from one-click checkout). */
export function isBookingPrepaid(appointment: Pick<Appointment, 'paymentData'>): boolean {
  return appointment.paymentData?.status === 'completed';
}
